import React from 'react';
import dateToHumanFormat from '../helpers/dateToHuman';

const TicketsTooltip = props => {
  const { selected, session, onDel, onClose, show, checkout } = props;
  if (selected.length == 0 || !show) return null;

  const selectedPlaces = session.places.filter(place =>
    selected.includes(place.id),
  );
  const selectedPlacesHtml = selectedPlaces.map(p => {
    return (
      <div key={p.id} className="ticket-popup__item">
        <p className="ticket-popup__item-text">
          <span className="key">
            Ряд {p.row}, место {p.place}
          </span>
          <span className="value"> {p.price} руб.</span>
        </p>
        <button
          type="button"
          className="ticket-popup__item-del"
          onClick={() => onDel(p.id)}
        />
      </div>
    );
  });

  if (checkout.bonusPay > 0) {
    selectedPlacesHtml.push(
      <div key="bonus" className="ticket-popup__item">
        <p className="ticket-popup__item-text">
          <span className="key">Оплата бонусами</span>
          <span className="value"> -{checkout.bonusPay} руб.</span>
        </p>
      </div>,
    );
  }

  return (
    <div className="ticket-popup__container">
      <button
        type="button"
        className="scheme-box__alert-close"
        onClick={() => onClose()}
      ></button>
      <h5 className="ticket-popup__film-name">{session.film.name}</h5>
      <p className="title-meta__item ticket-popup__text">
        {`${session.cinema.name}, ${session.cinema.address}, Зал ${
          session.hall
        }, ${dateToHumanFormat(session.datetime)}`}
      </p>
      {selectedPlacesHtml}
    </div>
  );
};

export default TicketsTooltip;
